import { Link } from "react-router-dom";
import type { FC } from "react";

import { mobileNavigationLinks, navigationLinks } from "../../consts";

import styles from "./NavigationList.module.scss";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";

interface NavigationProps {
    onClick?: () => void;
}

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md);

export const NavigationList: FC<NavigationProps> = ({ onClick }) => {
    const isMobile = useMediaQuery(mediaQuery);
    const commonLinkProps = { onClick, className: styles.link };

    const list = (!isMobile ? navigationLinks : mobileNavigationLinks).map(({ to, title }) => (
        <li className={styles.item} key={title}>
            <Link to={to} {...commonLinkProps}>
                {title}
            </Link>
        </li>
    ));

    return (
        <nav>
            <ul className={styles.list}>{list}</ul>
        </nav>
    );
};
